import queryString from 'query-string';

const FERNUS_QUERY_KEYS = ['mp3', 'pdf', 'swf', 'xaml'];

export const isCdnVideo = (videoLink) =>
  Boolean(videoLink && videoLink.indexOf('source=cdn') > -1);

export const isFernusVideo = (videoLink) => {
  if (!videoLink) {
    return false;
  }

  const lower = videoLink.toLowerCase();
  return lower.includes('frns.in') || lower.includes('/soru_cozum/web_player');
};

export const parseVideoUrl = (cndLink) => {
  if (!cndLink) {
    return '';
  }

  const {
    query: { url },
  } = queryString.parseUrl(cndLink);

  return url || '';
};

const appendQueryParams = (baseUrl, extraParams) => {
  const keys = Object.keys(extraParams);
  if (!keys.length) {
    return baseUrl;
  }

  const query = keys
    .map((key) => `${key}=${extraParams[key]}`)
    .join('&');
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}${query}`;
};

export const getFernusEmbedUrl = (videoLink) => {
  if (!videoLink) {
    return '';
  }

  if (isFernusVideo(videoLink) && videoLink.indexOf('url=') === -1) {
    return videoLink;
  }

  const parsed = queryString.parseUrl(videoLink);
  const innerUrl = parsed.query && parsed.query.url;

  if (innerUrl && isFernusVideo(innerUrl)) {
    const extraParams = FERNUS_QUERY_KEYS.reduce((acc, key) => {
      if (parsed.query[key] && innerUrl.indexOf(`${key}=`) === -1) {
        acc[key] = parsed.query[key];
      }
      return acc;
    }, {});

    return appendQueryParams(innerUrl, extraParams);
  }

  if (isFernusVideo(videoLink)) {
    return videoLink;
  }

  return '';
};

export const getSolutionIframeSrc = (videoLink) => {
  if (!videoLink) {
    return '';
  }

  if (isFernusVideo(videoLink)) {
    return getFernusEmbedUrl(videoLink);
  }

  const vimeoUrl = parseVideoUrl(videoLink) || videoLink;
  if (!vimeoUrl) {
    return '';
  }

  return appendQueryParams(vimeoUrl, {
    autoplay: '1',
    color: 'f34a53',
    title: '0',
    byline: '0',
    portrait: '0',
  });
};
